/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 // Megamenu
 $(document).ready(function() {
    $(function() {
      var header = $("#section-header");
      $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
          header.addClass("sticky-header");
        } else {
          header.removeClass("sticky-header");
        }
      });
    });
    
    // Cart Drawer
    var productLength = $('.cart__main-item[data-template="custom-plastic"]').length;
    var customProductLength2 = $('.cart__main-item[data-template="custom-full-wrap"]').length;
    var customProductLength3 = $('.cart__main-item[data-template="custom-paper"]').length;
    var customProductLength4 = $('.cart__main-item[data-template="custom-sleev-coast-napkin"]').length;
    if(productLength >= 1 || customProductLength2 >= 1 || customProductLength3 >= 1 || customProductLength4 >= 1){
      $('.cart-drawer-right').removeClass('remove-shipping-input')
    }else{
      $('.cart-drawer-right').addClass('remove-shipping-input')
    }
    
    // Product Gallery slider
    $('.product__slideshow').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable:false,
      arrows: false,
      focusOnSelect: false,
      asNavFor: '.Product__SlideshowNavScroller'
    });
    $('.Product__SlideshowNavScroller').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product__slideshow',
      dots: false,
      infinite: true,
      arrows:true,
      vertical: true,
      verticalSwiping: true,
      // centerMode: true,
      focusOnSelect: true,
      prevArrow:'<button class="slick-prev prev-arrow"><svg width="40px" height="40px" viewBox="0 0 24 24"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Arrow" transform="translate(-384.000000, 0.000000)"><g id="right_line" transform="translate(384.000000, 0.000000)"><path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"></path><path d="M15.7072,11.2929 C16.0977,11.6834 16.0977,12.3166 15.7072,12.7071 L10.0503,18.364 C9.65982,18.7545 9.02666,18.7545 8.63613,18.364 C8.24561,17.9734 8.24561,17.3403 8.63613,16.9497 L13.5859,12 L8.63613,7.05025 C8.24561,6.65973 8.24561,6.02656 8.63613,5.63604 C9.02666,5.24551 9.65982,5.24551 10.0503,5.63604 L15.7072,11.2929 Z" fill="#09244B"></path></g></g></g></svg></button>',
      nextArrow:'<button class="slick-next next-arrow"><svg width="40px" height="40px" viewBox="0 0 24 24"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Arrow" transform="translate(-384.000000, 0.000000)"><g id="right_line" transform="translate(384.000000, 0.000000)"><path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"></path><path d="M15.7072,11.2929 C16.0977,11.6834 16.0977,12.3166 15.7072,12.7071 L10.0503,18.364 C9.65982,18.7545 9.02666,18.7545 8.63613,18.364 C8.24561,17.9734 8.24561,17.3403 8.63613,16.9497 L13.5859,12 L8.63613,7.05025 C8.24561,6.65973 8.24561,6.02656 8.63613,5.63604 C9.02666,5.24551 9.65982,5.24551 10.0503,5.63604 L15.7072,11.2929 Z" fill="#09244B"></path></g></g></g></svg></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            vertical: false,
            verticalSwiping: false,
          }
        }
      ]
    });
    
    // Customer Review 
    $('.customer-review-sec').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        }
      }]
    });
    
    // Product Slider
    $('.feature-products-sec').slick({
      dots: false,
      arrows: true,
      prevArrow: '<button class="slide-arrow-main prev-arrow"><svg width="40px" height="40px" viewBox="0 0 24 24"><g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Arrow" transform="translate(-384.000000, 0.000000)"><g id="right_line" transform="translate(384.000000, 0.000000)"><path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"></path><path d="M15.7072,11.2929 C16.0977,11.6834 16.0977,12.3166 15.7072,12.7071 L10.0503,18.364 C9.65982,18.7545 9.02666,18.7545 8.63613,18.364 C8.24561,17.9734 8.24561,17.3403 8.63613,16.9497 L13.5859,12 L8.63613,7.05025 C8.24561,6.65973 8.24561,6.02656 8.63613,5.63604 C9.02666,5.24551 9.65982,5.24551 10.0503,5.63604 L15.7072,11.2929 Z" id="路径" fill="#09244B"></path></g></g></g></svg></button>',
      nextArrow: '<button class="slide-arrow-main next-arrow"><svg width="40px" height="40px" viewBox="0 0 24 24"><g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Arrow" transform="translate(-384.000000, 0.000000)"><g id="right_line" transform="translate(384.000000, 0.000000)"><path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"></path><path d="M15.7072,11.2929 C16.0977,11.6834 16.0977,12.3166 15.7072,12.7071 L10.0503,18.364 C9.65982,18.7545 9.02666,18.7545 8.63613,18.364 C8.24561,17.9734 8.24561,17.3403 8.63613,16.9497 L13.5859,12 L8.63613,7.05025 C8.24561,6.65973 8.24561,6.02656 8.63613,5.63604 C9.02666,5.24551 9.65982,5.24551 10.0503,5.63604 L15.7072,11.2929 Z" id="路径" fill="#09244B"></path></g></g></g></svg></button>',
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 551,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    // Pair product slider
    $('.pair-product-slider').slick({
      dots: false,
      infinite: false,
      speed: 300,
      arrows: true,
      prevArrow: '<button class="slide-arrow-main prev-arrow"><svg width="40px" height="40px" viewBox="0 0 24 24"><g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Arrow" transform="translate(-384.000000, 0.000000)"><g id="right_line" transform="translate(384.000000, 0.000000)"><path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"></path><path d="M15.7072,11.2929 C16.0977,11.6834 16.0977,12.3166 15.7072,12.7071 L10.0503,18.364 C9.65982,18.7545 9.02666,18.7545 8.63613,18.364 C8.24561,17.9734 8.24561,17.3403 8.63613,16.9497 L13.5859,12 L8.63613,7.05025 C8.24561,6.65973 8.24561,6.02656 8.63613,5.63604 C9.02666,5.24551 9.65982,5.24551 10.0503,5.63604 L15.7072,11.2929 Z" id="路径" fill="#09244B"></path></g></g></g></svg></button>',
      nextArrow: '<button class="slide-arrow-main next-arrow"><svg width="40px" height="40px" viewBox="0 0 24 24"><g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Arrow" transform="translate(-384.000000, 0.000000)"><g id="right_line" transform="translate(384.000000, 0.000000)"><path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"></path><path d="M15.7072,11.2929 C16.0977,11.6834 16.0977,12.3166 15.7072,12.7071 L10.0503,18.364 C9.65982,18.7545 9.02666,18.7545 8.63613,18.364 C8.24561,17.9734 8.24561,17.3403 8.63613,16.9497 L13.5859,12 L8.63613,7.05025 C8.24561,6.65973 8.24561,6.02656 8.63613,5.63604 C9.02666,5.24551 9.65982,5.24551 10.0503,5.63604 L15.7072,11.2929 Z" id="路径" fill="#09244B"></path></g></g></g></svg></button>',
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
       {
         breakpoint: 768,
         settings: {
           dots: true,
           arrows: false,
           slidesToShow: 3,
           slidesToScroll: 3
         }
       },
       {
         breakpoint: 400,
         settings: {
           dots: true,
           arrows: false,
           slidesToShow: 2,
           slidesToScroll: 2
         }
       }
      ]
    });
   
     // Collection page filter
     // var $divs = $("div.product-box");
     // var numericallyOrderedDivs = $divs.sort(function(a, b) {
     //   return parseFloat($(a).find("h2").text()) > parseFloat($(b).find("h2").text()) ? 1 : -1;
     // });
     // $("#ProductList").html(numericallyOrderedDivs);
     $('#refine-by-wrapper').hide();
     var e = [],
       t = "",
       m = '';
     var spacesReplaced ='';
     $('.tag-group input[type="radio"]').change(function(o) {
       o.preventDefault(),
         setTimeout(function() {
           (e = []),
           $('#refine-by-wrapper').show();  
           $(".tag-group input:checked").each(function() {
             $('.reset-filter').addClass('show-btn');
             $('.selected_box').remove();
             e.push($(this).val());
             for(var i = 0; i < e.length; i++ ){
               var handlesubName = e[i].replaceAll(' ', '-');
               var handleName = handlesubName.replaceAll('.', ' ');
               var addDiv = '<div class="selected_box" data-title='+handleName+'>'+ e[i] +' <span class="remove_check">&times;</span></div>'
               $('.desktop-filter-handle').append(addDiv);
             }
             let text = e.toString();
             spacesReplaced = text.replaceAll(' ', '-');
             m = spacesReplaced
           });
           var n = m.replaceAll(',', '+'),
             a = '/collections/all',
             l = location.origin,
             u = l + a + "/" + n;
           var pageURL = $(location).attr("href");
           var hhh = pageURL + "/" + n;
           if (n == '') {
             $('.reset-filter').removeClass('show-btn');
           }
           $.ajax({
             url: hhh,
             type: "GET",
             success: function(d, response, urlPath) {
               $('body').removeClass('drawer-open');
               $('html, body').animate({
                 scrollTop: $('.CollectionInner').position().top - 50
               }, 'slow');
               $(".ProductListSection").html($(d).find(".ProductListSection").html());
             },
           });
         }, 200);
     });
     var z = [],
       v = "",
       y = '';
     var spacesReplaceda ='';
     $(document).on("click", ".remove_check", function() {
       var dataTitle = $(this).parents('.selected_box').data('title');
       dataId = dataTitle.replaceAll(' ', '-');
         $('#'+dataId).prop('checked', false);
         $(this).parents('.selected_box').remove();
       
         setTimeout(function() {
         $(".tag-group input:checked").each(function() {           
           z.push($(this).val());
           let text = z.toString();
           spacesReplaceda = text.replaceAll(' ', '-');
           m = spacesReplaceda
         });
         var n = m.replaceAll(',', '+'),
             a = '/collections/all',
             l = location.origin,
             u = l + a + "/" + n;
         var pageURL = $(location).attr("href");
         var hhh = pageURL + "/" + n;
         if (n == '') {
           $('.reset-filter').removeClass('show-btn');
         }
         $.ajax({
           url: hhh,
           type: "GET",
           success: function(d, response, urlPath) {
             $('body').removeClass('drawer-open');
             $('html, body').animate({
               scrollTop: $('.CollectionInner').position().top - 50
             }, 'slow');
             $(".ProductListSection").html($(d).find(".ProductListSection").html());
           },
         });
         }, 500);
         $(".tag-group input").each(function() {
             var checkedVal = $('.tag-group input:checked').length;
             if( checkedVal == 0 ){
               $('#refine-by-wrapper').hide();  
             }
         });
     });  
     $('.tag-group').each(function() {
       if ($(this).is(':empty')) {
         $(this).parents('.filter-group').hide();
       }
     });
     $('.mobile-filter-handle span').click(function() {
       $('body').addClass('drawer-open');
     });
     $('.filter-close').click(function() {
       $('body').removeClass('drawer-open');
     });
     $('.reset-filter').click(function() {
       $('#refine-by-wrapper').hide();  
       $('.selected_box').remove();
       $('input[type="radio"]').prop('checked', false);
       var g = location.pathname,
         h = location.origin,
         j = h + g;
       $.ajax({
         url: j,
         type: "GET",
         success: function(d) {
           $('body').removeClass('drawer-open');
           $('html, body').animate({
             scrollTop: $('.CollectionInner').position().top - 50
           }, 'slow');
           $(".ProductListSection").html($(d).find(".ProductListSection").html());
         },
       });
       $(this).removeClass('show-btn');
     });
     // Collection page
     $('.CollectionToolbar__Group button').click(function() {
       $('body').addClass('drawer-open');
       $('.CollectionInner__Sidebar').addClass('open-sidebar');
     });
     $('.collection-overlay,.sidebar-close span').click(function() {
       $('body').removeClass('drawer-open');
       $('.CollectionInner__Sidebar').removeClass('open-sidebar');
     });
     // Header
     $(window).scroll(function() {
       if ($(this).scrollTop() > 50) {
         $('#section-header').removeClass('header--transparent');
       } else {
         $('#section-header').addClass('header--transparent');
       }
     });
     $(window).on('load', function() {
       if ($(this).scrollTop() > 50) {
         $('#section-header').removeClass('header--transparent');
       } else {
         $('#section-header').addClass('header--transparent');
       }
     });
     // About page slider
     $('.logo-list').slick({
       slidesToShow: 10,
       slidesToScroll: 1,
       autoplay: true,
       autoplaySpeed: 0,
       speed: 7000,
       pauseOnHover: false,
       cssEase: 'linear',
       arrows: false,
       dots: false,
       responsive: [{
           breakpoint: 1360,
           settings: {
             slidesToShow: 7,
             speed: 7000,
             slidesToScroll: 7
           }
         },
         {
           breakpoint: 992,
           settings: {
             slidesToShow: 5,
             speed: 7000,
             slidesToScroll: 5
           }
         },
         {
           breakpoint: 768,
           settings: {
             slidesToShow: 4,
             speed: 7000,
             slidesToScroll: 4
           }
         },
         {
           breakpoint: 600,
           settings: {
             slidesToShow: 3,
             speed: 7000,
             slidesToScroll: 3
           }
         },
         {
           breakpoint: 480,
           settings: {
             slidesToShow: 2,
             speed: 7000,
             slidesToScroll: 2
           }
         }
       ]
     });
     // Product Page
          function updateBundleColorMessage() {
      $(window).on('load', function () {
  updateBundleColorMessage();
});
  if (!$('.bundle-cart-info').length) return;

  var bundleQty = parseInt($('#product_quantity').val(), 10) || 1;

  if (bundleQty <= 1) {
    $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add 1 more bundle to upgrade to two colors.</span>");
    $('.custom-color').removeClass('more-two-color more-four-color');

  } else if (bundleQty >= 2 && bundleQty < 4) {

    var addToFour = 4 - bundleQty;

    $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + addToFour + " more bundles to upgrade to three or four colors.</span>");

    $('.custom-color').addClass('more-two-color');
    $('.custom-color').removeClass('more-four-color');

  } else {

    $('.variant_bottom_info p').text("you're now eligible for three-four colors.");

    $('.custom-color').addClass('more-four-color');
    $('.custom-color').removeClass('more-two-color');
  }
}

updateBundleColorMessage();

$(document).on('click keyup change input', '.QuantitySelector__Button, .QuantitySelector__CurrentQuantity, .select-variant-btn', function () {
  setTimeout(updateBundleColorMessage, 100);
  setTimeout(updateBundleColorMessage, 500);
  setTimeout(updateBundleColorMessage, 1000);
});
     $('.customize__product h3,.product-desc-accordian h3,.product-shipping-accordian h3').click(function() {
       $(this).toggleClass('active');
       $(this).parents('.customize__product').toggleClass('active');
       $(this).next().slideToggle();
     });
     $('.ProductForm__Variants h3').click(function() {
       $(this).toggleClass('active');
       $(this).parents('.ProductForm__Variants').toggleClass('active');
       $(this).parents('.ProductForm__Variants').find('.ProductForm__Accordian').slideToggle();
     });
     $('.select-variant-btn a').click(function() {
       $(this).hide();
       $(this).parents('.select-variant-btn').find('.button-loader').show().delay(500).fadeOut();
       $(this).delay(1000).fadeIn(500).text('Selected');
       $(this).parents('.ProductForm__Accordian').delay(1500).slideToggle();
       $(this).parents('.ProductForm__Variants').find('h3').delay(1500).toggleClass('active');
       if ($('.customize__product').hasClass("active")) {
         $('.customize__options').delay(1500).slideDown();
       } else {
         $('.customize__options').delay(1500).slideToggle();
         $('.customize__product').find('h3').delay(1500).toggleClass('active');
       }
     });
     $('.change_qty_btn').click(function() {

       var href = $(this).attr( 'href' );
        $( 'html, body' ).animate({
		scrollTop: $( href ).offset().top - 100
        }, '1000' );
       
       $(this).parents('.customize__options').delay(1500).slideToggle();
       $(this).parents('.customize__product').find('h3').delay(1500).toggleClass('active');
       $(this).parents('.customize__product').toggleClass('active');
       if ($('.ProductForm__Variants').hasClass("active")) {
         $('.ProductForm__Accordian').delay(1500).slideDown();
         //       $('.ProductForm__Variants').find('h3').delay(1500).toggleClass('active');
       } else {
         $('.ProductForm__Accordian').delay(1500).slideToggle();
         $('.ProductForm__Variants').find('h3').delay(1500).toggleClass('active');
       }
       // $('html, body').animate({
       //   scrollTop: $('.ProductForm__Variants').position().top
       // }, 1500);
     });
     $('.SizeSwatchList label').each(function() {
       var variantPrice = $(this).find('.variant-price').text();
       var variantValue = $(this).find('.value-price').text();
       $(this).attr('data-price', variantPrice);
       $(this).attr('data-value', variantValue);
     });
     $('.SizeSwatchList input[type="radio"]').change(function() {
       if ($('input[data-index="2"]').prop('checked')) {
         $('#product_quantity').val('1');
         $('.custom-color-input input').val('');
         $('.QuantitySelector__CurrentQuantity').val('1');
         $('.variant__info h6').show();
         $('.product-notification').hide();
         var value = $(this).val();
         var unit = value.replace(/[^\d.]/g, '');
         var quantity = $('#product_quantity').val();
         var option_name = $(this).parents('.HorizontalList__Item').find('.option_name').text();
         var per_price = $(this).parents('.HorizontalList__Item').find('.per_price').text();
         var value_price = $(this).parents('.HorizontalList__Item').find('.value-price').text();
         var total = unit * quantity;
         $('.units .unit_price').html(total);
         $('.add_to_cart_sec p span.option-title').html(option_name);
         $('.per_price .units').html(per_price);
         $('.per-cup-price span').html('' + per_price + ' Per ' + option_name + '');
         var unit_name = $('.product__unit .units.product_variant').text();
         $('.total_unit_input').val(unit_name);
         if (value == '100/Pack') {
           $('.units .unit_price').html('100');          
           $('.quantity_notification').show();
         }else{
           $('.quantity_notification').hide();
         }
         var option_price = $(this).parents('.HorizontalList__Item').find('.variant-price span').text();
         var itemId = option_price.substring(1, option_price.length);
         $('.product__total input').val(itemId);
         $('.product__total .units').text('$' + itemId);
         var option_price1 = $('.product__total input').val();
         var total_price = option_price1 * quantity;
         $('.product__total .units').text('$' + total_price.toFixed(2));
         var variant_Name = $(this).val();
         var variant_Price = $(this).next().attr('data-price');
         var variant_Value = $(this).next().attr('data-value');
         $('.selected_variant p').text(variant_Name);
         var optionName = $(this).attr('data-lable');
         $(this).parents('.ProductForm').find('input[data-lable="' + optionName + '"]').prop("checked", true);
         var radioquantity = $('#product_quantity').val();
         var radiovariantQuantity = unit;
         var radioremainVariant = 5000 - radiovariantQuantity;
         var radioremainQuantity = radioremainVariant / 100;
         if (radiovariantQuantity >= 5000 && radiovariantQuantity < 10000) {
           var radioremainVariant1 = 10000 - radiovariantQuantity;
           var radioremainQuantity1 = radioremainVariant1 / 100;
           $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + radioremainQuantity1 + " more cases to upgrade to two colors.</span>");
           $('.custom-color').addClass('more-two-color');
           $('.custom-color').removeClass('more-four-color');
         } else if (radiovariantQuantity >= 10000) {
           $('.variant_bottom_info p').text("you're now eligible for three-four colors.");
           $('.custom-color').addClass('more-four-color');
           $('.custom-color').removeClass('more-two-color');
         } else {
           $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add " + radioremainQuantity + " more cases to upgrade to two colors.</span>");
           $('.custom-color').removeClass('more-two-color');
           $('.custom-color').removeClass('more-four-color');
         }
       }
       if ($('input[data-index="1"]').prop('checked')) {
         $('#product_quantity').val('1');
         $('.QuantitySelector__CurrentQuantity').val('1');
         $('.custom-color-input input').val('');
         $('.variant__info h6').hide();
         $('.product-notification').show();
         var value = $(this).val();
         var unit = value.replace(/[^\d.]/g, '');
         var quantity = $('#product_quantity').val();
         var option_name = $(this).parents('.HorizontalList__Item').find('.option_name').text();
         var per_price = $(this).parents('.HorizontalList__Item').find('.per_price').text();
         var value_price = $(this).parents('.HorizontalList__Item').find('.value-price').text();
         var total = unit * quantity;
         $('.units .unit_price').html(total);
         $('.add_to_cart_sec p span.option-title').html(option_name);
         $('.per_price .units').html(per_price);
         $('.per-cup-price span').html('' + per_price + ' Per ' + option_name + '');
         var unit_name = $('.product__unit .units.product_variant').text();
         $('.total_unit_input').val(unit_name);
         if (value == '100/Pack') {
           $('.units .unit_price').html('100');
           $('.quantity_notification').show();
         }else{
           $('.quantity_notification').hide();
         }
         var option_price = $(this).parents('.HorizontalList__Item').find('.variant-price span').text();
         var itemId = option_price.substring(1, option_price.length);
         $('.product__total input').val(itemId);
         $('.product__total .units').text('$' + itemId);
         var option_price1 = $('.product__total input').val();
         var total_price = option_price1 * quantity;
         $('.product__total .units').text('$' + total_price.toFixed(2));
         var variant_Name = $(this).val();
         var variant_Price = $(this).next().attr('data-price');
         var variant_Value = $(this).next().attr('data-value');
         $('.selected_variant p').text(variant_Name);
         var optionName = $(this).attr('data-lable');
         $(this).parents('.ProductForm').find('input[data-lable="' + optionName + '"]').prop("checked", true);
         var inputquantity = $('#product_quantity').val();
         var variantCase = $(this).val();
         var removeLetter = variantCase.replace('/Case','');
         var variantNum = Number(removeLetter);
         var variantNumber = $('.units .total_unit_input + .unit_price').text();
         var inputvariantQuantity = variantNumber;
         var remainVariant = (5000 - inputvariantQuantity) / variantNum;
         var inputvariantQuantity = unit;
         var remainVariant = 5000 - inputvariantQuantity;
         if (inputvariantQuantity >= 5000 && inputvariantQuantity < 10000) {
           var remainVariant1 = (10000 - inputvariantQuantity) / variantNum;
           var remainQuantity1 = Math.ceil(remainVariant1);
           $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + remainQuantity1 + " more cases to upgrade to three-four colors.</span>");
           $('.custom-color').addClass('more-two-color');
           $('.custom-color').removeClass('more-four-color');
         } else if (inputvariantQuantity >= 10000) {
           $('.variant_bottom_info p').text("you're now eligible for three-four colors.");
           $('.custom-color').addClass('more-four-color');
           $('.custom-color').removeClass('more-two-color');
         } else {
           var remainVariant2 = (5000 - inputvariantQuantity) / variantNum;
           var remainQuantity2 = Math.ceil(remainVariant2);
           $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add " + remainQuantity2 + " more cases to upgrade to two colors.</span>");
           $('.custom-color').removeClass('more-two-color');
           $('.custom-color').removeClass('more-four-color');
         }
       }
     });
     // Product Variant match
     $('.product_add_cart .SizeSwatchList input[type="radio"]').change(function() {
       var variantName = $(this).attr('data-lable');
       $(this).parents('.ProductForm').find('input[data-lable="' + variantName + '"]').prop("checked", true);
     });
     $('.QuantitySelector__Button').click(function() {
       setTimeout(function() {
         var ubit1 = $('.selected_variant p').text();
         var unit1 = ubit1.replace(/[^\d.]/g, '');
         if (unit1 == '1') {
           var unit1 = '1000';
         }
         var quantity1 = $('#product_quantity').val();
         var total1 = unit1 * quantity1;
         $('.units .unit_price').html(total1);
         var unit_name = $('.product__unit .units.product_variant').text();
         $('.total_unit_input').val(unit_name);
         $('.QuantitySelector__CurrentQuantity').val(quantity1);
         var option_price1 = $('.product__total input').val();
         var total_price = option_price1 * quantity1;
         $('.product__total .units').text('$' + total_price.toFixed(2));
         
         
          var selectVariant = $('.SizeSwatchList').find('input:checked').attr('data-index');
          var variantOption = $('.variant-quantity-'+selectVariant+'').text();
          if(variantOption != ''){
            const obj = JSON.parse(variantOption);
            var inputVal = $(".QuantitySelector__CurrentQuantity").val();
            var hasKey = inputVal in obj;
            var value = 0;
            var keyArray = [];
            if(hasKey) {
              value = obj[inputVal];
            }
            else {
              for (const property in obj) {
                keyArray.push(property)
              }            
              var indexArray = [];            
              for(var i=0; i<keyArray.length; i++){
                var item = Number(keyArray[i]);
                if(inputVal >= item){
                  indexArray.push(item)
                }
              }            
              var indexMax = Math.max(...indexArray);
              value = obj[indexMax];
            }
            var total_price = value * quantity1;
            var per_unit = total_price / total1;
            $('.product__total .units').text('$' + total_price.toFixed(2));
            $('.per_price .units').html('$'+per_unit.toFixed(2));
          }
         
       }, 500);
     });
     $('.QuantitySelector__Button').click(function() {

       setTimeout(function() {
         $(".SizeSwatchList input:checked").each(function() {
           var quantity = $('#product_quantity').val();
           var option_name = $(this).parents('.HorizontalList__Item').find('.option_name').text();
         });
         $('.SizeSwatchList  input[type="radio"]').change(function() {
           var quantity = $('#product_quantity').val();
           var option_name = $(this).parents('.HorizontalList__Item').find('.option_name').text();
         });
         if ($('input[data-index="2"]').prop('checked')) {
           var radioquantity = $('#product_quantity').val();
           var variantNumber = $('.units .total_unit_input + .unit_price').text();
           var radiovariantQuantity = variantNumber
           var radioremainVariant = 5000 - variantNumber;
           var radioremainQuantity = radioremainVariant / 100;
           
           if (radiovariantQuantity >= 5000 && radiovariantQuantity < 10000) {
             var radioremainVariant1 = 10000 - radiovariantQuantity;
             var radioremainQuantity1 = radioremainVariant1 / 100;
             $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + radioremainQuantity1 + " more cases to upgrade to three-four colors.</span>");
             $('.custom-color').addClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
             $('.custom-color-3 .input-color').val('');
             $('.custom-color-4 .input-color').val('');
             $('.color-3-fee').val('');
             $('.color-4-fee').val('');
             $('.color3-printed.fee-notification').hide();
               $('.color4-printed.fee-notification').hide();
               $('.custom-color-4 input').prop('readonly', true);
               $('.custom-color-4').addClass('bg-grey');
              $('.custom-color-3 input').prop('readonly', true);
               $('.custom-color-3').addClass('bg-grey');
              var colorValues = [];
              $('.input-color').each(function(){
                var colorVal = $(this).val();
                if(colorVal){
                  colorValues.push(colorVal);
                }
              })
              var colorString = colorValues.toString();
              if (colorString) {
                $('#color_input').val(colorString);
              }
           } else if (radiovariantQuantity >= 10000) {
             $('.variant_bottom_info p').text("you're now eligible for three-four colors.");
             $('.custom-color').addClass('more-four-color');
             $('.custom-color').removeClass('more-two-color');
           } else {
             $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add " + radioremainQuantity + " more cases to upgrade to two colors.</span>");
             $('.custom-color').removeClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');             
             $('.custom-color-2 .input-color').val('')
             $('.custom-color-3 .input-color').val('')
             $('.custom-color-4 .input-color').val('')
             $('.color-4-fee').val('');
             $('.color-3-fee').val('');
             $('.color3-printed.fee-notification').hide();
               $('.color4-printed.fee-notification').hide();
               $('.custom-color-4 input').prop('readonly', true);
               $('.custom-color-4').addClass('bg-grey');
              $('.custom-color-3 input').prop('readonly', true);
               $('.custom-color-3').addClass('bg-grey');
             var colorValues = [];
              $('.input-color').each(function(){
                var colorVal = $(this).val();
                if(colorVal){
                  colorValues.push(colorVal);
                }
              })
              var colorString = colorValues.toString();
              if (colorString) {
                $('#color_input').val(colorString);
              }
           }
         } else {
           var variantCase = $('.SizeSwatchList .HorizontalList__Item input:checked').val();
           var removeLetter = variantCase.replace('/Case','');
           var variantNum = Number(removeLetter);
           var inputquantity = $('#product_quantity').val();
           var variantNumber = $('.units .total_unit_input + .unit_price').text();
           var inputvariantQuantity = variantNumber;
           var remainVariant = (5000 - inputvariantQuantity) / variantNum;
           if (inputvariantQuantity >= 10000) {
             $('.variant_bottom_info p').text("you're now eligible for three-four colors.");
             $('.custom-color').addClass('more-four-color');
             $('.custom-color').removeClass('more-two-color');
           } else if (inputvariantQuantity >= 5000 && inputvariantQuantity < 10000) {
             var remainVariant1 = (10000 - inputvariantQuantity) / variantNum;
             var AddQuantity = Math.ceil(remainVariant1);
             $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + AddQuantity + " more cases to upgrade to three-four colors.</span>");
             $('.custom-color').addClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
             $('.custom-color-3 .input-color').val('');
             $('.custom-color-4 .input-color').val('');
             $('.color-3-fee').val('');
             $('.color-4-fee').val('');
             $('.color3-printed.fee-notification').hide();
               $('.color4-printed.fee-notification').hide();
               $('.custom-color-4 input').prop('readonly', true);
               $('.custom-color-4').addClass('bg-grey');
              $('.custom-color-3 input').prop('readonly', true);
               $('.custom-color-3').addClass('bg-grey');
              var colorValues = [];
              $('.input-color').each(function(){
                var colorVal = $(this).val();
                if(colorVal){
                  colorValues.push(colorVal);
                }
              })
              var colorString = colorValues.toString();
              if (colorString) {
                $('#color_input').val(colorString);
              }
           } else {
             var remainVariant2 = (5000 - inputvariantQuantity) / variantNum;
             var AddQuantity2 = Math.ceil(remainVariant2);
             $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add " + AddQuantity2 + " more cases to upgrade to two colors.</span>");
             $('.custom-color').removeClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
             $('.custom-color-2 .input-color').val('');
             $('.custom-color-3 .input-color').val('');
             $('.custom-color-4 .input-color').val('');
             $('.color-4-fee').val('');
             $('.color-3-fee').val('');
             $('.color3-printed.fee-notification').hide();
               $('.color4-printed.fee-notification').hide();
               $('.custom-color-4 input').prop('readonly', true);
               $('.custom-color-4').addClass('bg-grey');
              $('.custom-color-3 input').prop('readonly', true);
               $('.custom-color-3').addClass('bg-grey');
             var colorValues = [];
              $('.input-color').each(function(){
                var colorVal = $(this).val();
                if(colorVal){
                  colorValues.push(colorVal);
                }
              })
              var colorString = colorValues.toString();
              if (colorString) {
                $('#color_input').val(colorString);
              }
           }
         }
       }, 1000);
     });
     $('.QuantitySelector__CurrentQuantity').keyup(function() {
       var InoutQuantity = $(this).val();
       $('#product_quantity').val(InoutQuantity);
       var ubit1 = $('.selected_variant p').text();
       var unit1 = ubit1.replace(/[^\d.]/g, '');
       var total1 = unit1 * InoutQuantity;
       $('.units .unit_price').html(total1);
       var unit_name = $('.product__unit .units.product_variant').text();
       $('.total_unit_input').val(unit_name);
       $('.QuantitySelector__CurrentQuantity').val(InoutQuantity);
       var option_price1 = $('.product__total input').val();
       var total_price = option_price1 * InoutQuantity;
       $('.product__total .units').text('$' + total_price.toFixed(2));

       var selectVariant = $('.SizeSwatchList').find('input:checked').attr('data-index')
       var variantOption = $('.variant-quantity-'+selectVariant+'').text();
       if(variantOption != ''){
         const obj = JSON.parse(variantOption);
         var inputVal = $(".QuantitySelector__CurrentQuantity").val();
         var hasKey = inputVal in obj;
         var value = 0;
         var keyArray = [];
          if(hasKey) {
            value = obj[inputVal];
          }
          else {
            for (const property in obj) {
              keyArray.push(property)
            }            
            var indexArray = [];            
            for(var i=0; i<keyArray.length; i++){
              var item = Number(keyArray[i]);
              if(inputVal >= item){
                indexArray.push(item)
              }
            }            
            var indexMax = Math.max(...indexArray);
            value = obj[indexMax];
          }
         var total_price = value * InoutQuantity;
         var per_unit = total_price / total1;
         $('.product__total .units').text('$' + total_price.toFixed(2));
         $('.per_price .units').html('$'+per_unit.toFixed(2));
       }
       
       setTimeout(function() {
         $(".SizeSwatchList input:checked").each(function() {
           var quantity = $('#product_quantity').val();
           var option_name = $(this).parents('.HorizontalList__Item').find('.option_name').text();
         });
         $('.SizeSwatchList  input[type="radio"]').change(function() {
           var quantity = $('#product_quantity').val();
           $('.QuantitySelector__CurrentQuantity').val('1');
           var option_name = $(this).parents('.HorizontalList__Item').find('.option_name').text();
         });
         if ($('input[data-index="2"]').prop('checked')) {
           var radioquantity = $('#product_quantity').val();
           var variantNumber = $('.units .total_unit_input + .unit_price').text();
           var radiovariantQuantity = variantNumber
           var radioremainVariant = 5000 - variantNumber;
           var radioremainQuantity = radioremainVariant / 100;
           if (radiovariantQuantity >= 5000 && radiovariantQuantity < 10000) {
             var radioremainVariant1 = 10000 - radiovariantQuantity;
             var radioremainQuantity1 = radioremainVariant1 / 100;
             $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + radioremainQuantity1 + " more cases to upgrade to three-four colors.</span>");
             $('.custom-color').addClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
             $('.custom-color-3 .input-color').val('');
             $('.custom-color-4 .input-color').val('');
             $('.color-3-fee').val('');
             $('.color-4-fee').val('');
              $('.color3-printed.fee-notification').hide();
               $('.color4-printed.fee-notification').hide();
               $('.custom-color-4 input').prop('readonly', true);
               $('.custom-color-4').addClass('bg-grey');
              $('.custom-color-3 input').prop('readonly', true);
               $('.custom-color-3').addClass('bg-grey');
              var colorValues = [];
              $('.input-color').each(function(){
                var colorVal = $(this).val();
                if(colorVal){
                  colorValues.push(colorVal);
                }
              })
              var colorString = colorValues.toString();
              if (colorString) {
                $('#color_input').val(colorString);
              }
           } else if (radiovariantQuantity >= 10000) {
             $('.variant_bottom_info p').text("you're now eligible for three-four colors.");
             $('.custom-color').addClass('more-four-color');
             $('.custom-color').removeClass('more-two-color');
           } else {
             $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add " + radioremainQuantity + " more cases to upgrade to two colors.</span>");
             $('.custom-color').removeClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
             $('.custom-color-2 .input-color').val('');
             $('.custom-color-3 .input-color').val('');
             $('.custom-color-4 .input-color').val('');
             $('.color-4-fee').val('');
             $('.color-3-fee').val('');
             $('.color3-printed.fee-notification').hide();
               $('.color4-printed.fee-notification').hide();
               $('.custom-color-4 input').prop('readonly', true);
               $('.custom-color-4').addClass('bg-grey');
              $('.custom-color-3 input').prop('readonly', true);
               $('.custom-color-3').addClass('bg-grey');
             var colorValues = [];
              $('.input-color').each(function(){
                var colorVal = $(this).val();
                if(colorVal){
                  colorValues.push(colorVal);
                }
              })
              var colorString = colorValues.toString();
              if (colorString) {
                $('#color_input').val(colorString);
              }
           }
         } else {
           var variantCase = $('.SizeSwatchList .HorizontalList__Item input:checked').val();
           var removeLetter = variantCase.replace('/Case','');
           var variantNum = Number(removeLetter);
           var inputquantity = $('#product_quantity').val();
           var variantNumber = $('.units .total_unit_input + .unit_price').text();
           var inputvariantQuantity = variantNumber;
           var remainVariant = (5000 - inputvariantQuantity) / variantNum;
           if (inputvariantQuantity >= 10000) {
             $('.variant_bottom_info p').text("you're now eligible for three-four colors.");
             $('.custom-color').addClass('more-four-color');
             $('.custom-color').removeClass('more-two-color');
           } else if (inputvariantQuantity >= 5000 && inputvariantQuantity < 10000) {
             var remainVariant1 = (10000 - inputvariantQuantity) / variantNum;
             var AddQuantity = Math.ceil(remainVariant1);
             $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + AddQuantity + " more cases to upgrade to three-four colors.</span>");
             $('.custom-color').addClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
             $('.custom-color-3 .input-color').val('');
             $('.custom-color-4 .input-color').val('');
             $('.color-3-fee').val('');
             $('.color-4-fee').val('');
             $('.color3-printed.fee-notification').hide();
               $('.color4-printed.fee-notification').hide();
               $('.custom-color-4 input').prop('readonly', true);
               $('.custom-color-4').addClass('bg-grey');
              $('.custom-color-3 input').prop('readonly', true);
               $('.custom-color-3').addClass('bg-grey');
              var colorValues = [];
              $('.input-color').each(function(){
                var colorVal = $(this).val();
                if(colorVal){
                  colorValues.push(colorVal);
                }
              })
              var colorString = colorValues.toString();
              if (colorString) {
                $('#color_input').val(colorString);
              }
           } else {
             var remainVariant2 = (5000 - inputvariantQuantity) / variantNum;
             var AddQuantity2 = Math.ceil(remainVariant2);
             $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add " + AddQuantity2 + " more cases to upgrade to two colors.</span>");
             $('.custom-color').removeClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
             $('.custom-color-2 .input-color').val('');
             $('.custom-color-3 .input-color').val('');
             $('.custom-color-4 .input-color').val('');
             $('.color-4-fee').val('');
             $('.color-3-fee').val('');
             $('.color3-printed.fee-notification').hide();
               $('.color4-printed.fee-notification').hide();
               $('.custom-color-4 input').prop('readonly', true);
               $('.custom-color-4').addClass('bg-grey');
              $('.custom-color-3 input').prop('readonly', true);
               $('.custom-color-3').addClass('bg-grey');
             var colorValues = [];
              $('.input-color').each(function(){
                var colorVal = $(this).val();
                if(colorVal){
                  colorValues.push(colorVal);
                }
              })
              var colorString = colorValues.toString();
              if (colorString) {
                $('#color_input').val(colorString);
              }
           }
         }
       }, 1000);
     });
     $(".SizeSwatchList input:checked").each(function() {
       //     $('.selected__variant p').html(''+variant_Name+'<b>'+variant_Price+'</b><span>'+variant_Value+'</span>');
       if ($('input[data-index="2"]').prop('checked')) {
         $('#product_quantity').val('1');
         $('.variant__info h6').show();
         $('.product-notification').hide();
         var value = $(this).val();
         $('.selected_variant p').text(value);
         var unit = value.replace(/[^\d.]/g, '');
         var quantity = $('#product_quantity').val();
         var option_name = $(this).parents('.HorizontalList__Item').find('.option_name').text();
         var per_price = $(this).parents('.HorizontalList__Item').find('.per_price').text();
         var value_price = $(this).parents('.HorizontalList__Item').find('.value-price').text();
         var total = unit * quantity;
         $('.units .unit_price').html(total);
         $('.add_to_cart_sec p span.option-title').html(option_name);
         $('.per_price .units').html(per_price);
         $('.per-cup-price span').html('' + per_price + ' Per ' + option_name + '');
         var unit_name = $('.product__unit .units.product_variant').text();
         $('.total_unit_input').val(unit_name);
         if (value == '100/Pack') {
           $('.units .unit_price').html('100');          
           $('.quantity_notification').show();
         }else{
           $('.quantity_notification').hide();
         }
         var option_price = $(this).parents('.HorizontalList__Item').find('.variant-price span').text();
         var itemId = option_price.substring(1, option_price.length);
         $('.product__total input').val(itemId);
         $('.product__total .units').text('$' + itemId);
         var option_price1 = $('.product__total input').val();
         var total_price = option_price1 * quantity;
         $('.product__total .units').text('$' + total_price.toFixed(2));
         var optionName = $(this).attr('data-lable');
         $(this).parents('.ProductForm').find('input[data-lable="' + optionName + '"]').prop("checked", true);
         var variant_Name = $(this).val();
         var variant_Price = $(this).next().attr('data-price');
         var variant_Value = $(this).next().attr('data-value');
         var radioquantity = $('#product_quantity').val();
         var radiovariantQuantity = unit;
         var radioremainVariant = 5000 - radiovariantQuantity;
         var radioremainQuantity = radioremainVariant / 100;
         if (radiovariantQuantity >= 5000 && radiovariantQuantity < 10000) {
           var radioremainVariant1 = 10000 - radiovariantQuantity;
           var radioremainQuantity1 = radioremainVariant1 / 100;
           $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + radioremainQuantity1 + " more cases to upgrade to two colors.</span>");
           $('.custom-color').addClass('more-two-color');
           $('.custom-color').removeClass('more-four-color');
         } else if (radiovariantQuantity >= 10000) {
           $('.variant_bottom_info p').text("you're now eligible for three-four colors.");
           $('.custom-color').addClass('more-four-color');
           $('.custom-color').removeClass('more-two-color');
         } else {
           $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add " + radioremainQuantity + " more cases to upgrade to two colors.</span>");
           $('.custom-color').removeClass('more-two-color');
           $('.custom-color').removeClass('more-four-color');
         }
       }
       if ($('input[data-index="1"]').prop('checked')) {
         $('#product_quantity').val('1');
         $('.variant__info h6').hide();
         $('.product-notification').show();
         var value = $(this).val();
         $('.selected_variant p').text(value);
         var unit = value.replace(/[^\d.]/g, '');
         var quantity = $('#product_quantity').val();
         var option_name = $(this).parents('.HorizontalList__Item').find('.option_name').text();
         var per_price = $(this).parents('.HorizontalList__Item').find('.per_price').text();
         var value_price = $(this).parents('.HorizontalList__Item').find('.value-price').text();
         var total = unit * quantity;
         $('.units .unit_price').html(total);
         $('.add_to_cart_sec p span.option-title').html(option_name);
         $('.per_price .units').html(per_price);
         $('.per-cup-price span').html('' + per_price + ' Per ' + option_name + '');
         var unit_name = $('.product__unit .units.product_variant').text();
         $('.total_unit_input').val(unit_name);
         if (value == '100/Pack') {
           $('.units .unit_price').html('100');          
           $('.quantity_notification').show();
         }else{
           $('.quantity_notification').hide();
         }
         var option_price = $(this).parents('.HorizontalList__Item').find('.variant-price span').text();
         var itemId = option_price.substring(1, option_price.length);
         $('.product__total input').val(itemId);
         $('.product__total .units').text('$' + itemId);
         var option_price1 = $('.product__total input').val();
         var total_price = option_price1 * quantity;
         $('.product__total .units').text('$' + total_price.toFixed(2));
         var optionName = $(this).attr('data-lable');
         $(this).parents('.ProductForm').find('input[data-lable="' + optionName + '"]').prop("checked", true);
         var variant_Name = $(this).val();
         var variant_Price = $(this).next().attr('data-price');
         var variant_Value = $(this).next().attr('data-value');
         $('.selected_variant p').text(variant_Name);
         var optionName = $(this).attr('data-lable');
         $(this).parents('.ProductForm').find('input[data-lable="' + optionName + '"]').prop("checked", true);
         var inputquantity = $('#product_quantity').val();
         var variantCase = $(this).val();
         var removeLetter = variantCase.replace('/Case','');
         var variantNum = Number(removeLetter);
         var variantNumber = $('.units .total_unit_input + .unit_price').text();
         var inputvariantQuantity = variantNumber;
         var remainVariant = (5000 - inputvariantQuantity) / variantNum;
         var inputvariantQuantity = unit;
         var remainVariant = 5000 - inputvariantQuantity;
         if (inputvariantQuantity >= 5000 && inputvariantQuantity < 10000) {
           var remainVariant1 = (10000 - inputvariantQuantity) / variantNum;
           var remainQuantity1 = Math.ceil(remainVariant1);
           $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + remainQuantity1 + " more cases to upgrade to three-four colors.</span>");
           $('.custom-color').addClass('more-two-color');
           $('.custom-color').removeClass('more-four-color');
         } else if (inputvariantQuantity >= 10000) {
           $('.variant_bottom_info p').text("you're now eligible for three-four colors.");
           $('.custom-color').addClass('more-four-color');
           $('.custom-color').removeClass('more-two-color');
         } else {
           var remainVariant2 = (5000 - inputvariantQuantity) / variantNum;
           var remainQuantity2 = Math.ceil(remainVariant2);
           $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add " + remainQuantity2 + " more cases to upgrade to two colors.</span>");
           $('.custom-color').removeClass('more-two-color');
           $('.custom-color').removeClass('more-four-color');
         }
       }
     });

     // Add Bleed Fee Product
     $('.printing_fee .artwrok-radio-sec input').on('change',function(){
       var value = $(".printing_fee .artwrok-radio-sec input:checked").val();
        if (value == '2-Sided Printing') {
          $( ".change_qty_btn" ).append('<input type="hidden" id="bleed-fee" name="properties[2 Sided Printing Fee]" value="added" />');
        }else{
          $( ".change_qty_btn input" ).remove();
        }
     });
     $('.bleed-fee-product .artwrok-radio-sec input').on('change',function(){
        var value = $(".bleed-fee-product .artwrok-radio-sec input:checked").val();
        if (value == 'Full Bleed Printing') {
          $( ".change_qty_btn" ).append('<input type="hidden" id="bleed-fee" name="properties[Full Bleed Fee]" value="added" />');
        }else{
          $( ".change_qty_btn input" ).remove();
        }
     });

     // Add Custom PMS Mixing Fee Product
$('.artwrok-radio-sec input').on('change', function() {
    var value = $('.artwrok-radio-sec input:checked').val();

    // IMPORTANT: value must match exactly the radio's value text
    if (value == 'Want Custom PMS Mixing? (Extra Fee)') {
        $(".change_qty_btn").append(
            '<input type="hidden" id="Mixing-fee" name="properties[Custom PMS Mixing Fee]" value="added" />'
        );
    } else {
        $("#Mixing-fee").remove();
    }
});



     // Artwork Upload 
     $('.radio-body input[type="radio"],#artwork_radio input[type="radio"]').change(function() {
       $(".radio-body input:checked,#artwork_radio input:checked").each(function() {
         var inputValue = $(this).val();
         if (inputValue == 'yes') {
           $('.artwork-file-upload').addClass('one-side');
         }
         if (inputValue == '1-Sided Printing') {
           $('.artwork-file-upload').addClass('one-side');
         }
         if (inputValue == 'no') {
           $('.artwork-file-upload').removeClass('one-side');
         }
         if (inputValue == '2-Sided Printing') {
           $('.artwork-file-upload').removeClass('one-side');
         }
       });
     });
     if ($('.custom_product_template').hasClass('coffee-custom-product')) {
       $('.artwrok-radio-sec.other-collection,.coaster-collection-radio').empty();
     }
     if ($('.custom_product_template').hasClass('coaster-custom-product')) {
       $('.artwrok-radio-sec.other-collection,.sleeves-collection-radio').empty();
       $('.artwork-file-upload').addClass('one-side');
       $('.file-upload-body p.yes-answer').text('Upload Artwork : One Side');
     }
     if ($('.custom_product_template').hasClass('napkin-custom-product')) {
       $('.same-artwork-sec').empty();
       $('.artwork-file-upload').addClass('one-side');
       $('.file-upload-body p.yes-answer').text('Upload Artwork : One Side');
     }  
     if ($('.custom_product_template').hasClass('disable-customize')){
       $('.coaster-collection-radio,.sleeves-collection-radio').empty()
     }  
     $(".radio-body input:checked,#artwork_radio input:checked").each(function() {
       var inputValue = $(this).val();
       if (inputValue == 'yes') {
         $('.artwork-file-upload').addClass('one-side');
       }
       if (inputValue == '1-Sided Printing') {
         $('.artwork-file-upload').addClass('one-side');
       }
       if (inputValue == 'no') {
         $('.artwork-file-upload').removeClass('one-side');
       }
       if (inputValue == '2-Sided Printing') {
         $('.artwork-file-upload').removeClass('one-side');
       }
     });
   
     // HEX to pantone 
     function color() {
         $(".cp1").CanvasColorPicker({
             flat: true,
             color: {
                 r: 255,
                 g: 204,
                 b: 0
             },
             onColorChange: function(rgb, hsv) {
                 var hex = COLOR_SPACE.RGB2HEX(rgb);
                 var cmyk = COLOR_SPACE.rgb2ymck(rgb);
                 var p = this.getProximity();
                 $('#Matchingto').html('PMS colors close to RGB color #' + hex + '&nbsp;<span style="background-color:#' + hex + ';">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> ' +
                     ', max color distance : ' + p);
                 var ww = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                 if (ww > 800) {
                     aww = ww - 400;
                 } else {
                     aww = ww;
                 } //remove width of ad block 
                 if (aww <= 400) {
                     bpl = 3;
                 } else if (aww < 500) {
                     bpl = 4;
                 } else if (aww < 600) {
                     bpl = 5;
                 } else if (aww < 800) {
                     bpl = 6;
                 } else {
                     bpl = 7;
                 }
                 var m = PMSColorMatching(hex, p);
                 var m2 = '';
                 if ((m.length) > 0) {
                     for (var i = 0; i < m.length; i++) {
                         rgbcode = PMS2RGB(m[i]);
                         m2 = m2 + '<div class="divPMSBlock">' +
                             '<div class="divPMSBlockTitle" >' + m[i] + '</div>' +
                             '<div class="divPMSBlockColor" style="background:#' + rgbcode + '"></div></div>';
                     }
                 }    
                 $('#PMScolors').html(m2);    
             }
         });
         $('#proximity').bind("change", function() {
             var ww = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
             if (ww > 800) {
                 aww = ww - 400;
             } else {
                 aww = ww;
             } //remove width of ad block 
             if (aww <= 400) {
                 bpl = 3;
             } else if (aww < 500) {
                 bpl = 4;
             } else if (aww < 600) {
                 bpl = 5;
             } else if (aww < 800) {
                 bpl = 6;
             } else {
                 bpl = 7;
             }
             var hex = document.getElementById('RGB').value;
             var p = document.getElementById('proximity').value;
             var m = PMSColorMatching(hex, p);
             var m2 = '';
             if ((m.length) > 0) {
                 for (var i = 0; i < m.length; i++) {
                     rgbcode = PMS2RGB(m[i]);
                     m2 = m2 + '<div class="divPMSBlock">' +
                         '<div class="divPMSBlockTitle" >' + m[i] + '</div>' +
                         '<div class="divPMSBlockColor" style="background:#' + rgbcode + '"></div></div>';
                 }
             }    
             $('#PMScolors').html(m2);    
         });    
     }
   color();  
     // Click To remove color
     $('.custom-color-input svg').click(function() {
       $('body').addClass('color-modal-open'); 
       setTimeout(function() {
         color();
       }, 2500);
     });
     $('.color-guid-modal-close,.modal-overlay').click(function() {
       $('body').removeClass('color-modal-open');
     });  

   
     // Product page tab
     $('.product-info-wrapper ul.tab-nav li.tab-link').click(function() {
       var tab_id = $(this).attr('data-tab');  
       $('.product-info-wrapper ul.tab-nav li.tab-link').removeClass('current');
       $('.tab-content').removeClass('current');  
       $(this).addClass('current');
       $("#" + tab_id).addClass('current');
     });  
   
     // Inquiry modal
     $('.cart__footer [data-ajax-cart-section] a').click(function(e) {
       e.preventDefault();
       $('body').addClass('open-inquiry-modal');
     });
     $('.inquiry-modal-close,.modal-overlay').click(function() {
       $('body').removeClass('open-inquiry-modal');
     });
   
     // Request Quote Form
     var ItemName = $('.select_item_type').find('option:selected').val();
     if (ItemName == '') {
       $('.size-instruction-btn').addClass('disabel')
     } else {
       $('.size-instruction-btn').addClass('disabel')
     }
     $('.product-information-field').each(function() {
       $('.select_item_type').change(function() {
         var ItemName = $(this).find('option:selected').data('value');
         var SelectedVal = $(this).find('option:selected').val();
         if (SelectedVal == '') {
           $('.size-instruction-btn').addClass('disabel')
         } else {
           $('.size-instruction-btn').removeClass('disabel')
         }
         var Inputval = $('.selected-value').val();
         $('.selected-value').attr('data-class', Inputval);
         var InputAttr = $('.selected-value').attr('data-class');
         var Index = $(this).parents('.product-information-field').attr('data-index');
         var modalID = parseFloat(Index) + 1;
         var dataChartImg = $(this).find('option:selected').attr('data-size-img');
         setTimeout(function() {
           $('.selected-value').val(ItemName);
           var Inputval2 = $('.selected-value').val();
           if(dataChartImg == ''){
             $('.size-instruction-btn').addClass('disabel');
           }else{
             $('.size-instruction-btn').removeClass('disabel');
           }
           $('.modal-size-img').each(function() {
              var dataClass = $(this).attr('data-class');
              $(this).hide();
              if(Inputval2 == dataClass){
                $('[data-class="'+Inputval2+'"]').show();
              }
          })
         }, 500);
       });
       $('.size-instruction-btn,.size-chart span').click(function() {
         $('body').addClass('open-modal');
       });
     });
     $('.modal-close,.modal-overlay').click(function() {
       $('body').removeClass('open-modal');
     });
   
     //FAQ mobile dropdown
     if ($(window).width() < 768) {
       $(function() {
         var list = $('.faq-dropdown-body');
         var link = $('.faq-dropdown');
         link.click(function(e) {
           e.preventDefault();
           list.slideToggle(200);
         });
         list.find('.faq-heading ').click(function() {
           var text = $(this).html();
           var icon = '<svg class="down" width="48px" height="48px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" fill="white" fill-opacity="0.01"/><path d="M37 18L25 30L13 18" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
           link.html(text + icon);
           list.slideToggle(200);
         });
       });
     }

     //FAQ page tab
     $('.faq-heading').click(function(e){
       e.preventDefault();
       let $this = $(this);

       if($this.hasClass('current')){
         $this.removeClass('current')
         $this.siblings('.faq-content').slideUp();
       }else{
         $('.faq-heading').removeClass('current')
         $('.faq-content').slideUp();
         $this.addClass('current')
         $this.siblings('.faq-content').slideDown();
       }
     });
   
     //FAQ page Accordian
     $('.faq-body h6').click(function(e) {
       e.preventDefault();
       let $this = $(this);
       if ($this.next().hasClass('show')) {
         $this.next().slideUp(350);
         $this.next().removeClass('show');
         $this.removeClass('active-accordian');
       } else {
         $this.parent().parent().find('.faq-inner-body').removeClass('show');
         $('.faq-body h6').removeClass('active-accordian');
         $this.parent().parent().find('.faq-inner-body').slideUp(350);
         $this.next().toggleClass('show');
         $this.next().slideToggle(350);
         $this.toggleClass('active-accordian');
       }
     });
 });
 $(document).ready(function() {
   var today = new Date();
   var dd = today.getDate();
   var mm = today.getMonth() + 1; //January is 0!
   var yyyy = today.getFullYear();
   if (dd < 10) {
     dd = '0' + dd;
   }
   if (mm < 10) {
     mm = '0' + mm;
   }
   today = mm + '/' + dd + '/' + yyyy;
   var currentDate = new Date(today);
   $('#cart_calendar').click(function() {
     $('#CartForm-date').trigger('focus')
   });
   $("#CartForm-date").datepicker({
     dateFormat: 'mm/dd/yy',
     minDate: 0,
   });
   // Sample Request Form
   var trLength = $('#data-table tbody tr,#product-summary tbody tr').length;
   if (trLength == 0) {
     $('.product-data-table').hide();
     $('.product-add-wrapper,.product-information-field').show();
   }
    $('.sample-requset-wrapper .product-add-btn a').on('click', function() {
      var type_value = $('.item_type select option:selected').val();
      var count = $('#data-table tr').length;
      if (type_value != "") {
        $('#data-table tbody').append('<tr><td data-label="Product"><input hidden name="contact[Product Title' + count + ']" type="text" value="' + type_value + '"  />' + type_value + '</td><td><div class="product-remove-btn"><a href="javascript:void(0);" class="delete-btn"><svg id="bx-trash" xmlns="http://www.w3.org/2000/svg" width="14.4" height="16" viewBox="0 0 14.4 16"><path id="Path_1890" data-name="Path 1890" d="M4.75,16.5a1.6,1.6,0,0,0,1.6,1.6h8a1.6,1.6,0,0,0,1.6-1.6V6.9h1.6V5.3h-3.2V3.7a1.6,1.6,0,0,0-1.6-1.6H7.95a1.6,1.6,0,0,0-1.6,1.6V5.3H3.15V6.9h1.6ZM7.95,3.7h4.8V5.3H7.95Zm-.8,3.2h7.2v9.6h-8V6.9Z" transform="translate(-3.15 -2.1)" fill="#26addf"/><path id="Path_1891" data-name="Path 1891" d="M9.45,10.5h1.6v6.4H9.45Zm3.2,0h1.6v6.4h-1.6Z" transform="translate(-4.65 -4.1)" fill="#26addf"/></svg></a></div></td></tr>');
      }
      var trLength = $('#data-table tbody tr').length;
     if (trLength >= 1) {
       
       $('.product-add-wrapper,.product-information-field').hide();
       $('.product-data-table').show();
     } else {
       $('.product-data-table').hide();
     }
    });
   $('.add-more-btn a').click(function() {
      $('.product-add-wrapper,.product-information-field').show();
      $('.select-option .sub-dropdown li').removeClass('select-val');
      var type_img = $('.item_type li[disabled]').attr("data-img");
      var size_img = $('.item_size li[disabled]').attr("data-img");
      var lids_img = $('.item_lids li[disabled]').attr("data-img");
      $('.item_size .item_type_img').css('background-image', 'url(' + size_img + ')')
      $('.item_lids .item_type_img').css('background-image', 'url(' + lids_img + ')')
      $('.item_type .item_type_img').css('background-image', 'url(' + type_img + ')')
      $('.item_type .selected-value span').text("Select Item");
      $('.item_lids .selected-value span').text("Select Lids");
      $('.item_size .selected-value span').text("Select Size");
      $('.quantity-field').val("");
      $('.quote-accordian-body select option').show();
      var item_type = $('.item_type .sub-dropdown li.select-val').text();
      if (item_type == '') {
        $('.item_size .sub-optgroup').hide();
        $(".item_lids .sub-optgroup").hide();
        $('.item_lids').show();
      }
   });
   $(document).on('click', '.delete-btn', function() {
     $(this).parent().parent().parent().remove();
     var trLength = $('#data-table tbody tr,#product-summary tbody tr').length;
     if (trLength == 0) {
       $('.product-data-table').hide();
       $('.product-add-wrapper,.product-information-field').show();
     }
   });
   $('#reset').click(function() {
     $('.delete-btn').trigger('click');
   });
   // Size Guide Popup
   $('.size-guide a').click(function() {
     $('body').addClass('modal-open');
   });
   $('.modal-close,.modal-overlay').click(function() {
     $('body').removeClass('modal-open');
   });
   // quote Request page
   $('.product-information-field h3').click(function() {
     $(this).next().slideToggle();
     $(this).parent().toggleClass('active');
     $(this).toggleClass('active');
   });

   $(document).on("click", function(event){
      var $trigger = $(".item_type");
      if($trigger !== event.target && !$trigger.has(event.target).length){
          $(".item_type .sub-dropdown").slideUp("fast");
      } 
      var $trigger1 = $(".item_size");
      if($trigger1 !== event.target && !$trigger1.has(event.target).length){
          $(".item_size .sub-dropdown").slideUp("fast");
      } 
      var $trigger2 = $(".item_lids");
      if($trigger2 !== event.target && !$trigger2.has(event.target).length){
          $(".item_lids .sub-dropdown").slideUp("fast");
      }            
    });   
   
   $('.quote-request-form-sec .product-add-btn a').click(function() {
      var ProductQuantity = $('.quantity-field').val();
      var ProductItem = $('.item_type .sub-dropdown li.select-val').text();
      var ProductSize = $('.item_size .sub-dropdown li.select-val').text();
      var ProductLids = $('.item_lids .sub-dropdown li.select-val').text();
      var size_qunatity = $('.size-quantity-field').val();
      var lids_qunatity = $('.lids-quantity-field').val();
      if (ProductQuantity == "") {
       $('.quantity-field').addClass('error');
      } else {
       $('.quantity-field').removeClass('error');
      }
      if (ProductItem == "") {
       $('.item_type .selected-value').addClass('error');
      } else {
       $('.item_type .selected-value').removeClass('error');
      }
      var count1 = $('#product-summary tr').length;
      if (ProductItem != "") {
        $('#product-summary tbody').append('<tr><td data-label="Product"><input hidden name="contact[Product Title' + count1 + ']" type="text" value="' + ProductItem + '"  />' + ProductItem + '</td><td data-label="Size"><input hidden name="contact[Product Size' + count1 + ']" type="text" value="' + ProductSize + '"  />' + ProductSize + '</td><td data-label="Quantity"><input hidden name="contact[Size Quantity' + count1 + ']" type="text" value="' + size_qunatity + '"  />' + size_qunatity + '</td><td data-label="Lids"><input hidden name="contact[Product Lids' + count1 + ']" type="text" value="' + ProductLids + '"  />' + ProductLids + '</td><td data-label="Quantity"><input hidden name="contact[Lids Quantity' + count1 + ']" type="text" value="' + lids_qunatity + '"  />' + lids_qunatity + '</td><td><div class="product-remove-btn"><a href="javascript:void(0);" class="delete-btn"><svg id="bx-trash" xmlns="http://www.w3.org/2000/svg" width="14.4" height="16" viewBox="0 0 14.4 16"><path id="Path_1890" data-name="Path 1890" d="M4.75,16.5a1.6,1.6,0,0,0,1.6,1.6h8a1.6,1.6,0,0,0,1.6-1.6V6.9h1.6V5.3h-3.2V3.7a1.6,1.6,0,0,0-1.6-1.6H7.95a1.6,1.6,0,0,0-1.6,1.6V5.3H3.15V6.9h1.6ZM7.95,3.7h4.8V5.3H7.95Zm-.8,3.2h7.2v9.6h-8V6.9Z" transform="translate(-3.15 -2.1)" fill="#26addf"/><path id="Path_1891" data-name="Path 1891" d="M9.45,10.5h1.6v6.4H9.45Zm3.2,0h1.6v6.4h-1.6Z" transform="translate(-4.65 -4.1)" fill="#26addf"/></svg></a></div></td></tr>');
      }     
      var trLength = $('#product-summary tbody tr').length;
      if (trLength >= 1) {
        $('.product-data-table').show();
        $('.product-information-field').hide();
      } else {
        $('.product-data-table').hide();
      }
   });
   var DotsLength = $('.pair-product-sec .slick-dots li').length;
   if (DotsLength <= 1) {
     $('.pair-product-sec .slick-dots').hide();
   }
 });
 $(document).ready(function() {
   var options = {
     dots: false,
     infinite: false,
     arrows:true,
     speed: 300,
     slidesToShow: 1,
     slidesToScroll: 1,
     prevArrow: $('.chart-prev'),
     nextArrow: $('.chart-next')
   }
  $('.size-chart span').on('click', function() {
    $('body').addClass('open-modal');
    $('.size-chart-slider').slick('unslick');
    $('.size-chart-slider').slick(options);
    if ($(window).width() < 767){
      const zoomArea = document.querySelectorAll(".size-chart-img ");
      const zoomIn = document.querySelectorAll(".zoom-in");
      const zoomOut = document.querySelectorAll(".zoom-out");
      const zoomRange = document.querySelectorAll(".zoom-range");
      const reset = document.querySelectorAll(".reset");

      [...zoomArea].forEach((elem) => {
        const panzoom = Panzoom(elem, {
          maxScale: 4
        });
        const parent = elem.closest(".size-modal-body");
        parent.addEventListener("wheel", panzoom.zoomWithWheel);
      });

    }
     
  });
    $('.size-chart-slider').on('init', function() {});
    $('.size-chart-slider').slick(options);
 });
 (function(){
     //gett all the video elements on the document
     var vids = document.getElementsByClassName('_autoplay_vid');     
     //loop through all the video elements
     for (var i = vids.length - 1; i >= 0; i--) {
       //pause all the videos by default
       vids[i].pause();
     }    
     //triger an anonymous function that handles the playy, pause video actions
     window.onscroll = function(){
         for (var i = vids.length - 1; i >= 0; i--) {          
             //get current scrol position
             var currentYpos = window.pageYOffset || document.documentElement.scrollTop;            
         if ( currentYpos >= vids[i].offsetTop 
             && currentYpos <= vids[i].offsetTop + vids[i].offsetHeight 
            ) {
             //Play video if the current scroll position 
             //is between the top and bottom of the video element
           vids[i].play();
         }else{
             //else pause the video 
           vids[i].pause();
         }
       }
     };
 });
 // Cart Recommendation
$(document).ready(function(){  
   // Collection desktop filter
   $(document).on("click",".desktop_filter_action",function(){
     $(this).parents(".CollectionInner").toggleClass("product_filter_grid");
   });

  // Cart Hover Js
  $(".cart-icon-hover").hover(function (e) {
    e.preventDefault();
    setTimeout(function() {
      $('body').addClass("js-my-cart-open");
    }, 1200)
  });

// Video Play On Hover
  $('.ecom_video').each(function(i, obj) {
    $('.ecom_video')[i].pause();
  });
  $('.ecom_video').each(function(i, obj) {
    $(this).on("mouseover", function() { hoverVideo(i); });
    $(this).on("mouseout", function() { hideVideo(i); });
  });
  function hoverVideo(i) {  
    $('.ecom_video')[i].play(); 
  }
  function hideVideo(i) {
    $('.ecom_video')[i].pause(); 
  }
   
  // Country Dropdown
  $('.country-dropdown-selector').click(function(){
    $(this).parents('.country-dropdown').find('ul').slideToggle();
  });

  // Collection page Slider
  function collectionSlick() {
    $('.collection-link,.main-category-slider').slick({
        dots: false,
        arrows:true,  
        infinite: false,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 7,
        prevArrow: '<button class="slide-arrow-main prev-arrow"><svg width="800px" height="800px" viewBox="0 0 24 24"><g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Arrow" transform="translate(-384.000000, 0.000000)"><g id="right_line" transform="translate(384.000000, 0.000000)"><path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"></path><path d="M15.7072,11.2929 C16.0977,11.6834 16.0977,12.3166 15.7072,12.7071 L10.0503,18.364 C9.65982,18.7545 9.02666,18.7545 8.63613,18.364 C8.24561,17.9734 8.24561,17.3403 8.63613,16.9497 L13.5859,12 L8.63613,7.05025 C8.24561,6.65973 8.24561,6.02656 8.63613,5.63604 C9.02666,5.24551 9.65982,5.24551 10.0503,5.63604 L15.7072,11.2929 Z" id="路径" fill="#09244B"></path></g></g></g></svg></button>',
        nextArrow: '<button class="slide-arrow-main next-arrow"><svg width="800px" height="800px" viewBox="0 0 24 24"><g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Arrow" transform="translate(-384.000000, 0.000000)"><g id="right_line" transform="translate(384.000000, 0.000000)"><path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"></path><path d="M15.7072,11.2929 C16.0977,11.6834 16.0977,12.3166 15.7072,12.7071 L10.0503,18.364 C9.65982,18.7545 9.02666,18.7545 8.63613,18.364 C8.24561,17.9734 8.24561,17.3403 8.63613,16.9497 L13.5859,12 L8.63613,7.05025 C8.24561,6.65973 8.24561,6.02656 8.63613,5.63604 C9.02666,5.24551 9.65982,5.24551 10.0503,5.63604 L15.7072,11.2929 Z" id="路径" fill="#09244B"></path></g></g></g></svg></button>',
        responsive: [
          {
            breakpoint: 1599,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 6
            }
          },
          {
            breakpoint: 1359,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          },        
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
    });
  }
  collectionSlick();
  

  // Add Class in add to cart btn
  $('.coaster-custom-product .ProductForm__BuyButtons button,.coffee-custom-product .ProductForm__BuyButtons button').addClass('add-custom-fee');

  // Gallery Popup
  var options = {
   dots: false,
   infinite: false,
   arrows:true,
   speed: 300,
   slidesToShow: 1,
   slidesToScroll: 1,
   prevArrow: $('.popup-prev-arrow'),
   nextArrow: $('.popup-next-arrow')
  }

  $('.gallery-popup-body').on('init', function(){});
  $('.gallery-popup-body').slick(options);
  $('.gallery-img-body').click(function(){
    var dataIndex = $(this).attr('data-index');
    var index = dataIndex - 1;
    $('body').addClass('gallery-popup-open');
    $('.gallery-popup-body').on('init', function() {});
    $('.gallery-popup-body').slick('unslick');
    $('.gallery-popup-body').slick(options);
    $('.gallery-popup-body').slick('slickGoTo', index)
  });
  $('.close-btn').click(function(){
    $('body').removeClass('gallery-popup-open');
  });

  // Category Slider Slide to go
  var dataIndex = $('.collection-link').find('.collection-inner.active-collection').attr('data-slick-index');
  $('.collection-link').slick('slickGoTo', dataIndex)
  
});

$(window).on('load',function(){
  var dataIndex = $('.collection-link').find('.collection-inner.active-collection').attr('data-slick-index');
  $('.collection-link').slick('slickGoTo', dataIndex);
});


$(document).ready(function(){
   
  $('.CartItem__Remove').click(function(){
    var getOrderId = localStorage.getItem("orderNo");
    localStorage.removeItem('orderNo')
  });
  var setOrder = localStorage.getItem("orderNo");
  var val = sessionStorage.getItem('date')  
  var d = new Date(val);
  var options = { year: 'numeric', month: 'short', day: 'numeric' };
  var customDate =  d.toLocaleDateString('en-US', options);
  if(setOrder != ''){
    setTimeout (function(){
      var orderNo = setOrder.replace('Order','');
      if(val){
        $('#cart-note').val('REORDER OF INVOICE '+orderNo+' Event Date: '+customDate+'');
      }else{
        $('#cart-note').val('REORDER OF INVOICE '+orderNo+'');  
      }
      
    }, 700);
  }
  // Reorder 
  $('.reorder-btn').click(function(){
    var orderNo = ''
    var formData = {
        items: []
    }
    $('.line-item-wrapper').each(function() {
      orderNo = $(this).parents('.order-wrapper').find('h1.SectionHeader__Heading.Heading.u-h1').text();
      var InputValue = {};
       $(this).find('.property').each(function(){
          var propertyName = $(this).attr('name');
          var propertyVal = $(this).val();
          InputValue[propertyName] = propertyVal;
      });
      formData.items.push({
        'id': $(this).find('.variant-id').val(),
        'quantity': $(this).find('.quantity').val(),
        'properties': {
          ...InputValue
        }
      });
      localStorage.setItem("orderNo", orderNo);
    });
     $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
      },
      dataType: 'json'
    });
    setTimeout(function() {
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .then(response => {
          window.location.href = "/cart";
          return response.json();          
      })
      .catch((error) => {
          console.error('Error:', error);
      });
    }, 1000)
  });

  // Add class in cart page
  var removetext = $('.my-cart__items').find('.remove-product b').text();                
  if(removetext == 'Screen/Plate Fee :'){
    $('.my-cart__items').find('.remove-product').closest('.cart__main-item').addClass('without-fee-product-1');
  }

  var remove1text = $('.my-cart__items').find('.remove-product1 b').text();
  if(remove1text == 'Screen Plate Fee :'){
    $('.my-cart__items').find('.remove-product1').closest('.without-fee-product').addClass('without-fee-product-0');
  }

 // Add multiple value in one input
  $('.input-color').change(function(){
    var colorValues = [];
    $('.input-color').each(function(){
      var colorVal = $(this).val();
      if(colorVal){
        colorValues.push(colorVal);
      }
    })
    var colorString = colorValues.toString();
    if (colorString) {
      $('#color_input').val(colorString);
    }      
  });

  // Show Fee notification
     $('.custom-color-3 input').keyup(function() {
       var color1 = $('.custom-color-1 input').val().length;
       var color2 = $('.custom-color-2 input').val().length;
       var color3 = $(this).val().length;
       if (color1 > 0 && color2 > 0 && color3 > 0) {
         $('.color-3-fee').val('added');
         $('.color3-printed.fee-notification').show();
         $('.color4-printed.fee-notification').hide();
         $('.custom-color-4 input').prop('readonly', false);
         $('.custom-color-4').removeClass('bg-grey');
       } else if (color1 != '' && color2 != '' && color3 == '') {
         $('.color-3-fee').val('');
         $('.color-4-fee').val('');
         $('.color3-printed.fee-notification').hide();
         $('.color4-printed.fee-notification').hide();
         $('.custom-color-4 input').prop('readonly', true);
         $('.custom-color-4').addClass('bg-grey');
         $('.custom-color-4 input').val('');
         var hghh = $('.custom-color-4 input').val()
       }
     });
     $('.custom-color-4 input').keyup(function() {
       var color1 = $('.custom-color-1 input').val().length;
       var color2 = $('.custom-color-2 input').val().length;
       var color3 = $('.custom-color-3 input').val().length;
       var color4 = $(this).val().length;
       if (color1 > 0 && color2 > 0 && color3 > 0 && color4 > 0) {
         $('.color-3-fee').val('');
         $('.color-4-fee').val('added');
         $('.color4-printed.fee-notification').show();
         $('.color3-printed.fee-notification').hide();
       } else if (color4 === 0) {
         $('.color-3-fee').val('added');
         $('.color-4-fee').val('')
         if($(this).parents('.custom-color-4 ').hasClass('bg-grey')){
           $('.color3-printed.fee-notification').hide();
         }else{
           $('.color3-printed.fee-notification').show();  
         }         
         $('.color4-printed.fee-notification').hide();
       }
     });

  // Custom product color input
  $('.custom-color-1 input').keyup(function(){
    var value = $(this).val().length;    
    if(value >= 1){
      $('.custom-color-2').removeClass('bg-grey');
      $('.custom-color-2 input').prop('readonly', false);
    }else{
      $('.custom-color-2').addClass('bg-grey');
      $('.custom-color-2 input').prop('readonly', true);
      $('.custom-color-2 input').val('');
      var inputVal2 = $('.custom-color-2 input').val();
      if(inputVal2 == ''){
        $('.custom-color-3 input').prop('readonly', true);
        $('.custom-color-3').addClass('bg-grey'); 
      } 
      $('.custom-color-3 input').val('');
      $('.custom-color-4 input').val('');
      var inputVal3 = $('.custom-color-3 input').val();      
      $('.color3-printed.fee-notification').hide();
      $('.color4-printed.fee-notification').hide();
      if(inputVal3 == ''){
        $('.custom-color-4 input').prop('readonly', true);
        $('.custom-color-4').addClass('bg-grey'); 
      } 
    }
  });
  $('.custom-color-2 input').keyup(function(){
    var value = $(this).val().length;    
    if(value >= 1){
      $('.custom-color-3').removeClass('bg-grey');
      $('.custom-color-3 input').prop('readonly', false);
    }else{
      $('.custom-color-3').addClass('bg-grey');
      $('.custom-color-3 input').prop('readonly', true);
      $('.custom-color-3 input').val('');
      $('.custom-color-4 input').val('');
      var inputVal3 = $('.custom-color-3 input').val();
      $('.color3-printed.fee-notification').hide();
      $('.color4-printed.fee-notification').hide();
      if(inputVal3 == ''){
        $('.custom-color-4 input').prop('readonly', true);
        $('.custom-color-4').addClass('bg-grey'); 
      }    
    }
  });
  window.onpageshow = function(event) {
    if (event.persisted) {
      window.location.reload()
    }
  };

  
  var filename = $('.filename').text().length;
  if(filename == 0){
    $('.file-wrapper').hide();
  }
  
  // Artwork Change
  $('.upload-side-1').change(function(){
    var file = this.files[0];
    if(file.name.length > 0){
      $(this).parents('.file-upload-body').find('.file-wrapper').show();
    }
    if (file.name.length >= 30) {
      $(this).parents('.file-upload-body').find(".filename").empty().append(file.name.substr(0, 30) + "..");
    } else {
      $(this).parents('.file-upload-body').find(".filename").empty().append(file.name);
    }
    var uri = window.location.toString();
    if (uri.indexOf("&edit") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("&edit"));
        window.history.replaceState({}, document.title, clean_uri);
    }
    var artworl_val1 = $(this).val().length;
    if(artworl_val1 > 0){
      if($('.artwork-file-upload').hasClass('one-side')){
        $('.artwork-val2').val('');
      }
      $('.artwork-val1').val('');
    }
  });

  $('.upload-side-2').change(function(){
    var file = this.files[0];
    if(file.name.length > 0){
      $(this).parents('.file-upload-body').find('.file-wrapper').show();
    }
    if (file.name.length >= 30) {
      $(this).parents('.file-upload-body').find(".filename").empty().append(file.name.substr(0, 30) + "..");
    } else {
      $(this).parents('.file-upload-body').find(".filename").empty().append(file.name);
    }
    var uri = window.location.toString();
    if (uri.indexOf("&edit") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("&edit"));
        window.history.replaceState({}, document.title, clean_uri);
    }
    var artworl_val2 = $(this).val().length;
    if(artworl_val2 > 0){
      $('.artwork-val2').remove('');
    }
  });

   // Set Value in product page
  var urlParams = new URLSearchParams(window.location.search);
  var editValCheck = urlParams.has('edit');
  var editVal = urlParams.get('edit');
  if(editValCheck && editVal){
    var totalunitval = urlParams.has('total-units');
    if(totalunitval == true){
      var unitval =urlParams.get('total-units');
      var removeSpace = unitval.replace(/^\s+|\s+$/gm,'');
      $('.product__unit .unit_price').text(removeSpace)
      $('.total_unit_input').val(removeSpace)
    } 
    var quantityCheck = urlParams.has('quantity');
    if(quantityCheck == true){
      var quantityval = urlParams.get('quantity');
      $('.QuantitySelector__CurrentQuantity').val(quantityval)
      $('#product_quantity').val(quantityval);
      // on window load change the logic
      setTimeout(function() {
        $(".SizeSwatchList input:checked").each(function() {
          var quantity = $('#product_quantity').val();
          var option_name = $(this).parents('.HorizontalList__Item').find('.option_name').text();
        });
        if ($('input[data-index="2"]').prop('checked')) {
          var radioquantity = $('#product_quantity').val();
          var variantNumber = $('.units .total_unit_input + .unit_price').text();
          var radiovariantQuantity = variantNumber
          var radioremainVariant = 5000 - variantNumber;
          var radioremainQuantity = radioremainVariant / 100;

          if (radiovariantQuantity >= 5000 && radiovariantQuantity < 10000) {
             var radioremainVariant1 = 10000 - radiovariantQuantity;
             var radioremainQuantity1 = radioremainVariant1 / 100;
             $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + radioremainQuantity1 + " more cases to upgrade to three-four colors.</span>");
             $('.custom-color').addClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
          } else if (radiovariantQuantity >= 10000) {
             $('.variant_bottom_info p').text("you're now eligible for three-four colors.");
             $('.custom-color').addClass('more-four-color');
             $('.custom-color').removeClass('more-two-color');
          } else {
             $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add " + radioremainQuantity + " more cases to upgrade to two colors.</span>");
             $('.custom-color').removeClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
          }
        } else {
          var inputquantity = $('#product_quantity').val();
          var variantNumber = $('.units .total_unit_input + .unit_price').text();
          var inputvariantQuantity = variantNumber;
          var remainVariant = 5000 - inputvariantQuantity;
          if (inputvariantQuantity >= 10000) {
             $('.variant_bottom_info p').text("you're now eligible for three-four colors.");
             $('.custom-color').addClass('more-four-color');
             $('.custom-color').removeClass('more-two-color');
          } else if (inputvariantQuantity >= 5000 && inputvariantQuantity < 10000) {
             var remainVariant1 = 10000 - inputvariantQuantity;
             var remainQuantity1 = remainVariant1 / 1000;
             var AddQuantity = Math.ceil(remainQuantity1);
             $('.variant_bottom_info p').html("you're now eligible for two colors,<span> Add " + AddQuantity + " more cases to upgrade to three-four colors.</span>");
             $('.custom-color').addClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
          } else {
             var remainVariant2 = 5000 / inputvariantQuantity;
             var AddQuantity2 = Math.ceil(remainVariant2);
             $('.variant_bottom_info p').html("you're now eligible for one color,<span> Add " + AddQuantity2 + " more cases to upgrade to two colors.</span>");
             $('.custom-color').removeClass('more-two-color');
             $('.custom-color').removeClass('more-four-color');
          }
        }
      }, 1000);

      setTimeout(function() {
        var ubit1 = $('.selected_variant p').text();
        var unit1 = ubit1.replace(/[^\d.]/g, '');
        if (unit1 == '1') {
         var unit1 = '1000';
        }
        var quantity1 = $('#product_quantity').val();
        var total1 = unit1 * quantity1;
        $('.units .unit_price').html(total1);
        var unit_name = $('.product__unit .units.product_variant').text();
        $('.total_unit_input').val(unit_name);
        $('.QuantitySelector__CurrentQuantity').val(quantity1);    

        var selectVariant = $('.SizeSwatchList').find('input:checked').attr('data-index');
        var variantOption = $('.variant-quantity-'+selectVariant+'').text();
        if(variantOption != ''){
          const obj = JSON.parse(variantOption);
          var inputVal = $(".QuantitySelector__CurrentQuantity").val();
          var hasKey = inputVal in obj;
          var value = 0;
          var keyArray = [];
          if(hasKey) {
            value = obj[inputVal];
          }
          else {
            for (const property in obj) {
              keyArray.push(property)
            }            
            var indexArray = [];            
            for(var i=0; i<keyArray.length; i++){
              var item = Number(keyArray[i]);
              if(inputVal >= item){
                indexArray.push(item)
              }
            }            
            var indexMax = Math.max(...indexArray);
            value = obj[indexMax];
          }
          var total_price = value * quantity1;
          var per_unit = total_price / total1;
          $('.product__total .units').text('$' + total_price.toFixed(2));
          $('.per_price .units').html('$'+per_unit.toFixed(2));
        }

      }, 500);

    }
    var colorValCheck = urlParams.has('color');
    if(colorValCheck == true){
      var colorVal =urlParams.get('color');
      var colorSplit = colorVal.split(',');
      var color1 = colorSplit[0];
      var color2 = colorSplit[1];
      var color3 = colorSplit[2];
      var color4 = colorSplit[3];
      $('#color_input').val(colorVal)
      if(color1 != ''){
        $('.custom-color-1 input').val(color1);
      }
      if(color2 != ''){
        $('.custom-color-2 input').val(color2);
      }
      if(color3 != ''){
        $('.custom-color-3 input').val(color3);
      }
      if(color4 != ''){
        $('.custom-color-4 input').val(color4);
      }
      var color1 = $('.custom-color-1 input').val().length;
      var color2 = $('.custom-color-2 input').val().length;
      var color3 = $('.custom-color-3 input').val().length;
      var color4 = $('.custom-color-4 input').val().length;
      if(color1 >= 1){
        $('.custom-color-2').removeClass('bg-grey');
        $('.custom-color-2 input').prop('readonly', false);
      }
      if(color2 >= 1){
        $('.custom-color-3').removeClass('bg-grey');
        $('.custom-color-3 input').prop('readonly', false);
      }
      if(color3 >= 1){
        $('.custom-color-4').removeClass('bg-grey');
        $('.custom-color-4 input').prop('readonly', false);
      }
      if (color1 > 0 && color2 > 0 && color3 > 0) {
        $('.color-3-fee').val('added');
        $('.color3-printed.fee-notification').show();
        $('.color4-printed.fee-notification').hide();
        $('.custom-color-4 input').prop('readonly', false);
        $('.custom-color-4').removeClass('bg-grey');
      }
      if (color1 > 0 && color2 > 0 && color3 > 0 && color4 > 0) {
        $('.color-3-fee').val('');
        $('.color-4-fee').val('added');
        $('.color4-printed.fee-notification').show();
        $('.color3-printed.fee-notification').hide();
      }
      
    }

    // Coaster Collection
    var coasterArtworkvalcheck = urlParams.has('coasters');
    if(coasterArtworkvalcheck){
      var coasterArtworkval = urlParams.get('coasters');
      var coasterArtwork1 = urlParams.get('upload-artwork-side-1');
      if(coasterArtwork1){
        $( ".customize__options" ).append('<input type="hidden" class="artwork-val1" name="properties[Upload Artwork : Side-1]" value="'+ coasterArtwork1 +'" />');
      }
      if (coasterArtworkval == 'Center Printing') {
         $(".coaster-collection-radio #center-printing").prop("checked", true); 
      }
      if (coasterArtworkval == 'Full Bleed Printing') {
         $(".coaster-collection-radio #full-bleed-printing").prop("checked", true); 
         $( ".change_qty_btn" ).append('<input type="hidden" id="bleed-fee" name="properties[Full Bleed Fee]" value="added" />');
      }
    }

    // Coffee Collection
    var coffeeartworkvalcheck = urlParams.has('sleeves');
    if (coffeeartworkvalcheck) {
      var coffeeArtworkval = urlParams.get('sleeves');
      var coffeeArtwork1 = urlParams.get('upload-artwork-side-1');
      var coffeeArtwork2 = urlParams.get('upload-artwork-side-2');
      if(coffeeArtwork1){
        $( ".customize__options" ).append('<input type="hidden" class="artwork-val1" name="properties[Upload Artwork : Side-1]" value="'+ coffeeArtwork1 +'" />');
      }
      if(coffeeArtwork2){
        $( ".customize__options" ).append('<input type="hidden" class="artwork-val2" name="properties[Upload Artwork : Side-2]" value="'+ coffeeArtwork2 +'" />');
      }
      if (coffeeArtworkval == '1-Sided Printing') {
         $(".sleeves-collection-radio #1-sided-printing").prop("checked", true); 
      }
      if (coffeeArtworkval == '2-Sided Printing') {
         $(".sleeves-collection-radio #2-sided-printing").prop("checked", true); 
         $( ".change_qty_btn" ).append('<input type="hidden" id="bleed-fee" name="properties[2 Sided Printing Fee]" value="added" />');
      }
      $(".radio-body input:checked,#artwork_radio input:checked").each(function() {
         var inputValue = $(this).val();
         if (inputValue == '1-Sided Printing') {
           $('.artwork-file-upload').addClass('one-side');
         }
         if (inputValue == '2-Sided Printing') {
           $('.artwork-file-upload').removeClass('one-side');
         }
      });
    }

    // Other Collection
    var artworkvalcheck = urlParams.has('same-artwork-on-both-sides');
    if(artworkvalcheck){
      var artworkval = urlParams.get('same-artwork-on-both-sides');
      var artwork1 = urlParams.get('upload-artwork-side-1');
      var artwork2 = urlParams.get('upload-artwork-side-2');
      if(artwork1){
        $( ".customize__options" ).append('<input type="hidden" class="artwork-val1" name="properties[Upload Artwork : Side-1]" value="'+ artwork1 +'" />');
      }
      if(artwork2){
        $( ".customize__options" ).append('<input type="hidden" class="artwork-val2" name="properties[Upload Artwork : Side-2]" value="'+ artwork2 +'" />');
      }
      if(artworkval == 'no'){
        $(".other-collection #no").prop("checked", true);
      }else if (artworkval == 'yes') {
        $(".other-collection #yes").prop("checked", true);
      }
      $(".radio-body input:checked,#artwork_radio input:checked").each(function() {
         var inputValue = $(this).val();
         if (inputValue == 'yes') {
           $('.artwork-file-upload').addClass('one-side');
         }
         if (inputValue == 'no') {
           $('.artwork-file-upload').removeClass('one-side');
         }
      });
    }
  }

  // Remove qty on cart count
  var fullqty = ''
  fullqty = $('.full-bleed-fee .item-quantity input').val();
  if(fullqty == undefined){
    fullqty = '';
  }else{
    fullqty = Number($('.full-bleed-fee .item-quantity input').val());
  }
  var pritningqty = ''
  pritningqty = $('.2nd-side-printing-fee .item-quantity input').val();
  if(pritningqty == undefined){
    pritningqty = '';
  }else{
    pritningqty = Number($('.2nd-side-printing-fee .item-quantity input').val());
  }
  var cartQty = $('.Header__CartDot').text();
  var totalqty = fullqty + pritningqty;
  if(cartQty > totalqty){
    var totalQty = cartQty - totalqty;
    $('.Header__CartDot').text(totalQty);
  }else {
    $('.Header__CartDot').text(cartQty);
  }

  // Cart page remove cart count
  var fullqty = ''
  fullqty = $('.full-bleed-fee .QuantitySelector__CurrentQuantity').val();
  if(fullqty == undefined){
    fullqty = '';
  }else{
    fullqty = Number($('.full-bleed-fee .QuantitySelector__CurrentQuantity').val());
  }
  var pritningqty = ''
  pritningqty = $('.2nd-side-printing-fee .QuantitySelector__CurrentQuantity').val();
  if(pritningqty == undefined){
    pritningqty = '';
  }else{
    pritningqty = Number($('.2nd-side-printing-fee .QuantitySelector__CurrentQuantity').val());
  }
  var cartQty = $('.Header__CartDot').text();
  var totalqty = fullqty + pritningqty;
  if(cartQty > totalqty){
    var totalQty = cartQty - totalqty;
    $('.Header__CartDot').text(totalQty);
  }else {
    $('.Header__CartDot').text(cartQty);
  }

  // Event date
  $('.event-date-checkbox input[type="checkbox"]').click(function(){
      if($(this).prop("checked") == true){
        $('#cart-shipping-input,#ContactForm-date').css({'background': "rgba(17,37,51,.2)", 'opacity': "0.5" });
        $('#cart-shipping-input,#ContactForm-date').attr("disabled", 'disabled');
        $('#event-date').attr("checked", 'checked');
        sessionStorage.removeItem('date'); 
        setTimeout (function(){
          console.log('ghyujhg')  
          $('#cart-note,.cart__footer textarea').val('No Event Date');
        }, 1000)
        localStorage.setItem('EventDate', 1);
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + 'No Event Date',
          dataType: 'json',
          success: function(cart) {
            console.log(cart)
          },
          error: function(XMLHttpRequest, textStatus) {

          }
        };
        jQuery.ajax(params);
        
      }
      else if($(this).prop("checked") == false){
        $('#cart-shipping-input,#ContactForm-date').css({'background': "#fff", 'opacity': "1" });
        $('#cart-shipping-input,#ContactForm-date').removeAttr("disabled");        
        localStorage.setItem('EventDate', 0);
        sessionStorage.removeItem('Cart Note');
        $('#cart-note,.cart__footer textarea').val('');
      }
    localStorageCheckBoxState();
  });
  localStorageCheckBoxState();
  function localStorageCheckBoxState(){
    if(localStorage.getItem('EventDate') == '1') {
      $('#cart-shipping-input,#ContactForm-date').css({'background': "rgba(17,37,51,.2)", 'opacity': "0.5" });
      $('#cart-shipping-input,#ContactForm-date').attr("disabled", 'disabled');
      $('#event-date').attr("checked", 'checked');
      sessionStorage.removeItem('date');       
      sessionStorage.removeItem('Cart Note');
      
      jQuery.ajax(params);
      var cartnotevalue = sessionStorage.getItem('Cart Note');
      if(cartnotevalue){
        setTimeout (function(){
          console.log('true')  
          $('#cart-note,.cart__footer textarea').val(cartnotevalue);
        }, 1000)
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + cartnotevalue,
          dataType: 'json',
          success: function(cart) {
            console.log(cart)
          },
          error: function(XMLHttpRequest, textStatus) {
  
          }
        };
      }else{
        setTimeout (function(){
          console.log('true')  
          var checkedNote = 'No Event Date' + cartnotevalue;
          $('#cart-note,.cart__footer textarea').val('No Event Date');
          console.log('checkedNote',checkedNote);
        }, 1000)
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + 'No Event Date',
          dataType: 'json',
          success: function(cart) {
            console.log(cart)
          },
          error: function(XMLHttpRequest, textStatus) {
  
          }
        };
      }
    }else if(localStorage.getItem('EventDate') == '0'){
      $('#cart-shipping-input,#ContactForm-date').css({'background': "#fff", 'opacity': "1" });
      $('#cart-shipping-input,#ContactForm-date').removeAttr("disabled");      
      var cartnotevalue = sessionStorage.getItem('Cart Note');
      console.log('cartnotevalue',cartnotevalue);
      if(!cartnotevalue){
        sessionStorage.removeItem('date');       
        sessionStorage.removeItem('Cart Note');
        $('#cart-note,.cart__footer textarea').val('');
        console.log('false')
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + ' ',
          dataType: 'json',
          success: function(cart) {
            console.log(cart)
          },
          error: function(XMLHttpRequest, textStatus) {
  
          }
        };
        jQuery.ajax(params);
      }else{
        $('#cart-note,.cart__footer textarea').val(cartnotevalue);
        console.log('false')
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + cartnotevalue,
          dataType: 'json',
          success: function(cart) {
            console.log(cart)
          },
          error: function(XMLHttpRequest, textStatus) {
  
          }
        };
        jQuery.ajax(params);
      }
      
    }
  }

});

// Back Btn Page Reload
if(performance.navigation.type == 2){
   location.reload(true);
}

window.onpageshow = function(event) {
  if (event.persisted) {
    window.location.reload()
  }
};

$(document).ready(function(){
  $('.cart-overlay').click(function(){
    setTimeout (function(){
      if($('body').hasClass('js-ajax-cart-empty')){
        $('.fee-wrapper').css('display','none');
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + '',
          dataType: 'json',
          success: function(cart) {
            console.log('emptycartr',cart)
          },
          error: function(XMLHttpRequest, textStatus) {
      
          }
        };
        jQuery.ajax(params);
        $('#ContactForm-date').val('');
      }
    }, 1000);
  });
});